import React from "react";
import Button from "../../button";
import classNames from "classnames";
import PropTypes from "prop-types";
import FormGroupSelectInput from "../../formGroupSelectInput";
import CustomSelect from "../customSelect";

const SelectableActionsForm = (props) => {
    const {
        selectedAction,
        onSelectAction,
        selectActions,
        selected,
        onSelectedActionApply,
        actionResultLoading
    } = props;
    return (
        <div className={"row form-group"}>
            <div className="col-sm-12">
                <hr className="appFormRefSettings-hr"/>
            </div>
            <div className={"col-sm-3"}>
                <CustomSelect
                    name={'selectedAction'}
                    onChange={onSelectAction}
                    value={selectedAction}
                    options={[
                        { key: "", value: "Select action..." },
                        ...selectActions.map(action => ({ key: action.key, value: action.label }))
                    ]}
                />

            </div>
            <div className={'col-sm-4'}>
                <Button
                    clickHandler={onSelectedActionApply}
                    wrapper="btn-wrapper"
                    btnType="button"
                    btnStyle={'btn btn-primary btn-xs sharp yellow'}
                    label="Apply"
                />
                {actionResultLoading && (
                    <div>loading ...</div>
                )}
            </div>
        </div>
    );
};

SelectableActionsForm.propTypes = {
    /** Selected key from options. Similar with the SelectInput component */
    selectedAction: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    /** Callback fired when the user selects an action. Similar with the onChange callback of the SelectInput
     * component*/
    onSelectAction: PropTypes.func,
    /** Array of options like the SelectInput component*/
    selectActions: PropTypes.array,
    /** Object containing the selected items */
    selected: PropTypes.object,
    /** Callback invoked when the user triggers an action */
    onSelectedActionApply: PropTypes.func,
    /** Boolean indicating the the action execution is loading*/
    actionResultLoading: PropTypes.bool
};

export default SelectableActionsForm;